import type {Result, UseCase} from 'framework';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MeasurementEntry} from '../../domain/measurement-entry';
import type {
  BodyMeasurementsRepository,
  SaveSessionInput,
} from '../ports/body-measurements.repository';

export class SaveMeasurementSession implements UseCase<
  [SaveSessionInput],
  readonly MeasurementEntry[]
> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(
    input: SaveSessionInput,
  ): Promise<Result<readonly MeasurementEntry[], BodyMeasurementsError>> {
    return this.repository.saveSession(input);
  }
}
